export default __webpack_public_path__ + "static/media/backgroud-heading.968e76f3.png";